const img = (id, w = 1600) => `https://images.unsplash.com/photo-${id}?auto=format&fit=crop&w=${w}&q=80`;

export const GREEN = "#043B1C";
export const GOLD = "#F4BE36";

export const IMAGES = {
  hero: img("1570129477492-45c003edd2be", 2000),
  residential: "/images/residential-truck.jpg",
  commercial: img("1486406146926-c627a92ad1ab", 1400),
  about: img("1605117882932-f9e32b03fea9", 1400),
};

export const services = [
  {
    slug: "spring-fall-clean-ups",
    hideIncluded: true,
    name: "Spring and Fall Clean Ups",
    cardDesc: "Seasonal property clean up to bookend the growing season right.",
    heroDesc: "A full property reset at the start and end of the season, bed clearing, debris removal, and prep work that sets up everything else you do outside.",
    image: "/images/spring-fall-clean-ups.jpg",
    seoTitle: "Spring and Fall Clean Up Services, Legacy Scapes Ltd",
    seoDesc: "Seasonal property clean up services, bed clearing, and debris removal for homes and businesses in the St. Clair Corridor.",
    included: [
      "Leaves, dead growth, and debris cleared from beds",
      "Lawn prep, light dethatching or aeration where needed",
      "Full haul away, nothing left behind",
      "One time or recurring, scheduled around your season",
    ],
    process: [
      { title: "Book Your Slot", text: "Book your slot, spring and fall clean ups fill quickly" },
      { title: "Full Property Pass", text: "We do a full property pass, beds, lawn edges, and hard surfaces" },
      { title: "Lawn Prep", text: "Lawn prep applied where needed" },
      { title: "Haul Away", text: "Everything is bagged and hauled away before we leave" },
    ],
    whoFor: "Both residential and commercial properties looking for a seasonal reset.",
    pricingNote: "Residential customers work with us through our subscription model. Commercial properties are quoted through a tailored contract built around the property's specific needs.",
  },
  {
    slug: "snow-removal",
    name: "Snow Removal",
    cardDesc: "Seasonal snow clearing you can count on before the plow trucks are even out.",
    heroDesc: "Legacy Scapes keeps driveways, walkways, and commercial lots clear all winter long, so residential and commercial property management clients never have to worry about the forecast.",
    image: "/images/snow-removal.jpg",
    seoTitle: "Snow Removal in the St. Clair Corridor, Legacy Scapes Ltd",
    seoDesc: "Reliable seasonal snow clearing for residential and commercial properties across the St. Clair Corridor.",
    included: [
      "Scheduled clearing of driveways, walkways, and lots",
      "Salt or ice management where needed",
      "Priority service for commercial properties with liability concerns",
      "Reliable service through the full winter season",
    ],
    process: [
      { title: "Pre-Season Booking", text: "Book your property before the season starts" },
      { title: "Confirm Service Triggers", text: "We confirm your triggers, like snowfall amount, for service" },
      { title: "Scheduled Clearing", text: "Your crew clears on schedule through the winter" },
      { title: "Commercial Priority", text: "Commercial accounts get priority based on their contract" },
    ],
    whoFor: "Both residential and commercial properties. Commercial and property management accounts are handled through a tailored winter contract.",
    pricingNote: "Residential customers work with us through our subscription model. Commercial and property management accounts are quoted through a tailored winter contract built around the property's specific needs.",
  },
  {
    slug: "lawn-care",
    name: "Lawn Care",
    cardDesc: "Recurring mowing and maintenance for residential customers, typically weekly.",
    heroDesc: "Recurring mowing and maintenance, typically on a weekly schedule, so your lawn stays consistent all season without you thinking about it.",
    image: "/images/lawn-care.jpg",
    image2: "/images/lawn-care-crew.jpg",
    seoTitle: "Lawn Care in the St. Clair Corridor, Legacy Scapes Ltd",
    seoDesc: "Recurring, reliable lawn mowing and maintenance for homes and businesses across the St. Clair Corridor. Reach out to request an estimate.",
    included: [
      "Weekly or recurring mowing and trimming",
      "Edging along beds, walkways, and fence lines",
      "Debris cleared from hard surfaces before we leave",
      "A consistent crew who knows your property",
    ],
    process: [
      { title: "Request an Estimate", text: "Request an estimate and tell us about your property" },
      { title: "Property Walkthrough", text: "We walk the property and set a recurring schedule" },
      { title: "Scheduled Service", text: "Your crew arrives on schedule, every visit" },
      { title: "Ongoing Care", text: "We flag anything unusual, like patchy growth, as we see it" },
    ],
    whoFor: "Primarily residential customers on our subscription plan, with recurring options available for smaller commercial properties too.",
    pricingNote: "Residential lawn care runs on a subscription model, a consistent recurring plan with predictable weekly visits and subscription based billing. Sign up, and the crew shows up on schedule. Commercial properties are quoted through a tailored contract built around the property's specific needs.",
  },
  {
    slug: "landscaping-enhancements",
    name: "Landscaping Enhancements",
    cardDesc: "Mulch installation and rock garden installs that keep your property polished.",
    heroDesc: "Mulch installation and rock garden installs that refresh your property's beds and keep them looking sharp through the season.",
    image: "/images/landscaping-enhancements.jpg",
    seoTitle: "Mulch and Rock Garden Installation, Legacy Scapes Ltd",
    seoDesc: "Mulch installation and rock garden enhancements for properties across Sarnia, Point Edward, Corunna, and the surrounding corridor.",
    included: [
      "Fresh mulch installation, refreshed beds that hold moisture and cut down on weeds",
      "Rock garden installation, designed to fit your property's layout",
      "Clean edging and bed definition around every install",
      "Debris and old material hauled away",
    ],
    process: [
      { title: "Property Walkthrough", text: "We walk your property and talk through what you're looking for" },
      { title: "Material Recommendation", text: "We recommend mulch or rock options suited to your beds" },
      { title: "Scheduled Installation", text: "Installation is scheduled at the right time of year" },
      { title: "Final Cleanup", text: "We clean up fully before we leave" },
    ],
    whoFor: "Both residential and commercial properties looking to refresh garden beds and landscaped areas.",
    pricingNote: "Residential customers work with us through our subscription model. Commercial properties are quoted through a tailored contract built around the property's specific needs.",
  },
];

export const towns = ["Sarnia", "Point Edward", "Corunna", "Courtright", "Port Lambton", "Petrolia"];

export const rotatingWords = ["Lawn Care", "Landscaping", "Snow Removal", "Seasonal Clean Ups"];
